/* Bluelander — tema v1.0.0 */
(function () {
  'use strict';
  var BL = window.BL || {};

  /* Centavos reales: antes se redondeaba a pesos ($485.10 → $485) y el precio
     en pantalla no coincidía con el checkout ni con Google Merchant. Sin
     centavos (precio cerrado) se sigue mostrando "$1,299". */
  function dinero(cent) {
    cent = Math.round(cent || 0);
    var dec = cent % 100 ? 2 : 0;
    return '$' + (cent / 100).toLocaleString('es-MX', { minimumFractionDigits: dec, maximumFractionDigits: dec });
  }
  var tt;
  function toast(m) {
    var t = document.getElementById('bl-toast');
    if (!t) return;
    t.textContent = m; t.classList.add('on');
    clearTimeout(tt); tt = setTimeout(function () { t.classList.remove('on'); }, 1800);
  }
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* Lo que el cliente realmente paga por un importe de lista, tras el
     descuento automático global (BLUE10%). Shopify compara el umbral de envío
     gratis contra el subtotal YA descontado; si la ficha compara con precio
     de lista, promete envío gratis que el checkout cobra. */
  function tras_descuento(cent) {
    var pct = parseFloat(BL.descuento_auto_pct) || 0;
    return pct > 0 ? Math.round(cent * (1 - pct / 100)) : cent;
  }

  /* Umbrales en centavos. En los ajustes se capturan en pesos. */
  function centEnvio() { return (BL.envio_gratis || 0) * 100; }
  function centMsi() { return (BL.msi_min || 0) * 100; }

  /* Barra de progreso de envío gratis — nativa del tema, sin depender de apps.
     Recibe el total en centavos (precio × cantidad) y regresa el HTML completo. */
  var AZUL_MARCA = '#1D4ED8';
  var VERDE_OK = '#15803D';

  function barraEnvio(totalCent, conCarrito) {
    var meta = centEnvio();
    if (!meta || meta <= 0) return '';
    if (totalCent >= meta) {
      // Con productos ya en el carrito el mensaje es prospectivo ("al agregarlo"),
      // para no contradecir al cajón, que habla del carrito tal cual está.
      var okTxt = conCarrito ? '✓ Envío gratis al agregarlo' : '✓ Envío gratis incluido';
      return '<div class="ship-bar" style="border:1px solid var(--line);border-radius:12px;padding:16px 18px;margin:0 0 16px;text-align:center">' +
        '<div style="font-size:14.5px;font-weight:700;color:' + VERDE_OK + ';margin-bottom:10px">' + okTxt + '</div>' +
        '<div style="height:8px;background:var(--line);border-radius:4px;overflow:hidden">' +
        '<div style="height:100%;width:100%;background:' + AZUL_MARCA + ';border-radius:4px"></div></div></div>';
    }
    var pct = Math.max(0, Math.min(100, Math.round((totalCent / meta) * 100)));
    var falta = meta - totalCent;
    return '<div class="ship-bar" style="border:1px solid var(--line);border-radius:12px;padding:16px 18px;margin:0 0 16px;text-align:center">' +
      '<div style="font-size:14.5px;font-weight:700;color:var(--ink)">Añade <span style="color:' + AZUL_MARCA + '">' + dinero(falta) + '</span> más y tu envío es gratis</div>' +
      '<div style="height:8px;background:var(--line);border-radius:4px;overflow:hidden;margin-top:10px">' +
      '<div style="height:100%;width:' + pct + '%;background:' + AZUL_MARCA + ';border-radius:4px;transition:width .25s"></div></div></div>';
  }

  /* Mensaje del carrito: envío gratis y MSI son condiciones independientes. */
  function mensajeCarrito(total) {
    if (!total || total <= 0) return '';
    var partes = [];
    if (total >= centEnvio()) partes.push('Envío gratis incluido');
    else partes.push('Faltan ' + dinero(centEnvio() - total) + ' para envío gratis');
    if (total >= centMsi()) partes.push('o ' + BL.msi + ' pagos de ' + dinero(total / BL.msi) + ' sin intereses');
    else partes.push('faltan ' + dinero(centMsi() - total) + ' para ' + BL.msi + ' meses sin intereses');
    return partes.join(' · ');
  }

  /* ── carrito ── */
  // Si viene de agregar(), recibe el carrito ya pintado y no vuelve a pedirlo.
  // body.bl-cajon-abierto: el CSS oculta los botones flotantes de apps
  // (WhatsApp) mientras el cajón está abierto — se encimaban sobre "Ir a pagar".
  function abrirCarrito(c) { var d = $('#bl-drawer'); if (d) { d.classList.add('on'); document.body.classList.add('bl-cajon-abierto'); pintarCarrito(c && c.items ? c : undefined); } }
  function cerrarCarrito() { var d = $('#bl-drawer'); if (d) d.classList.remove('on'); document.body.classList.remove('bl-cajon-abierto'); }

  /* Cambia la foto principal SOLO si es otra imagen (compara por id, no por
     URL). Reconstruye el srcset a partir de la URL de Shopify para que el
     navegador siga eligiendo el tamaño correcto: antes se quitaba el srcset
     y se forzaba un 1200w aunque la pantalla fuera de 400px. */
  /* ── video en la galería ──
     El video vive en un <template> por cada media de video (main-product.liquid)
     y solo se clona al tocar su miniatura. quitarVideo() lo pausa y lo retira
     para no seguir gastando datos cuando el cliente vuelve a una foto. */
  function quitarVideo() {
    var c = $('#stage-vid'); if (!c || c.hidden) return;
    var v = c.querySelector('video'); if (v) { try { v.pause(); } catch (e) {} }
    c.innerHTML = ''; c.hidden = true;
    var st = $('#stage'); if (st) st.classList.remove('con-video');
  }
  function mostrarVideo(id) {
    var t = document.getElementById('bl-vid-' + id), c = $('#stage-vid');
    if (!t || !c || !t.content) return false;
    c.innerHTML = '';
    c.appendChild(t.content.cloneNode(true));
    var v = c.querySelector('video');
    if (v) {
      // Silenciado + playsinline: así los navegadores dejan reproducir solo,
      // y en iPhone no salta a pantalla completa.
      v.muted = true; v.playsInline = true; v.setAttribute('playsinline', '');
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    c.hidden = false;
    var st = $('#stage'); if (st) st.classList.add('con-video');
    return true;
  }

  function cambiarFoto(url1200, imgId) {
    quitarVideo();
    var im = $('#pimg'); if (!im || !url1200) return;
    if (imgId != null && String(im.getAttribute('data-img-id')) === String(imgId)) return;
    if (!im.getAttribute('data-sizes')) im.setAttribute('data-sizes', im.getAttribute('sizes') || '');
    var conAncho = /([?&])width=\d+/.test(url1200);
    function w(n) { return conAncho ? url1200.replace(/([?&])width=\d+/, '$1width=' + n) : url1200; }
    im.removeAttribute('srcset'); im.removeAttribute('sizes');
    im.src = w(800);
    if (conAncho) {
      im.srcset = [400, 600, 800, 1000, 1400].map(function (n) { return w(n) + ' ' + n + 'w'; }).join(', ');
      var sz = im.getAttribute('data-sizes'); if (sz) im.setAttribute('sizes', sz);
    }
    if (imgId != null) im.setAttribute('data-img-id', imgId);
  }

  /* Texto seguro para meter en innerHTML (títulos de producto con < > & "). */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  /* Shopify PARTE una línea en dos cuando un descuento "Compra X y obtén Y"
     usa solo parte de las unidades para cumplir el mínimo (4 elefantes con
     etiqueta Regalo + 6 sin ella). Para el cliente es un solo producto: aquí
     se vuelven a juntar (misma variante y mismas propiedades). `keys` guarda
     todas las claves de línea para que ± y × actúen sobre el conjunto. */
  function fusionarLineas(items) {
    var out = [], idx = {};
    items.forEach(function (i) {
      var firma = esRegalo(i) ? 'R' + i.key : i.variant_id + '|' + JSON.stringify(i.properties || {});
      var j = idx[firma];
      if (j === undefined) {
        var copia = {}; for (var k in i) copia[k] = i[k];
        copia.keys = i.key; idx[firma] = out.length; out.push(copia);
      } else {
        var m = out[j];
        m.quantity += i.quantity;
        m.original_line_price += i.original_line_price;
        m.final_line_price += i.final_line_price;
        m.line_level_discount_allocations = (m.line_level_discount_allocations || []).concat(i.line_level_discount_allocations || []);
        m.keys += ',' + i.key;
      }
    });
    return out;
  }

  /* Pinta el cajón. Si ya se tiene el carrito (lo devuelven /cart/add.js y
     /cart/change.js) se pasa como argumento y se ahorra la petición extra. */
  function pintarCarrito(carrito) {
    var p = carrito ? Promise.resolve(carrito)
      : fetch(BL.routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    return p.then(function (c) {
        var n = $('#bl-cn');
        if (n) { n.textContent = c.item_count; n.classList.toggle('hide', c.item_count === 0); }
        var b = $('#bl-dbody');
        if (b) {
          b.innerHTML = c.items.length ? fusionarLineas(c.items).map(function (i) {
            // Miniatura al tamaño que se muestra (54px), no la foto original.
            var img = i.image ? i.image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_120x$1$2') : '';
            var regalo = esRegalo(i);
            return '<div class="ci' + (regalo ? ' ci-regalo' : '') + '"><img src="' + img + '" alt="" width="54" height="54" loading="lazy"><div>' +
              '<div class="t">' + esc(i.product_title) + '</div>' +
              (i.variant_title && i.variant_title.indexOf('Default') < 0 ? '<div class="mono" style="font-size:10.5px;color:var(--ink-3)">' + esc(i.variant_title) + '</div>' : '') +
              (regalo
                // El regalo lo administra el tema según el nivel: sin ± ni ×.
                ? '<div class="mono" style="font-size:10.5px;color:' + VERDE_OK + ';margin-top:5px;font-weight:600;letter-spacing:.04em;text-transform:uppercase">Regalo incluido</div>'
                : '<div class="ciq">' +
                '<button data-cq="' + i.keys + '" data-d="-1" aria-label="Quitar uno">−</button>' +
                '<span data-cqn="' + i.keys + '">' + i.quantity + '</span>' +
                '<button data-cq="' + i.keys + '" data-d="1" aria-label="Agregar uno">+</button>' +
                '<button data-cq="' + i.keys + '" data-d="0" aria-label="Quitar del carrito" title="Quitar" style="margin-left:6px">×</button>' +
              '</div>') +
              '</div><div class="p">' +
                (i.original_line_price > i.final_line_price
                  ? '<span class="was" style="display:block;font-size:11px;color:var(--ink-3);text-decoration:line-through">' + dinero(i.original_line_price) + '</span>' : '') +
                (regalo && i.final_line_price === 0 ? 'Gratis' : dinero(i.final_line_price)) +
                (function () {
                  // Nombre del descuento aplicado (BLUE10%, MIPRIMERACOMPRA…): el
                  // cliente veía $279 en la ficha y $251 aquí sin explicación.
                  var das = i.line_level_discount_allocations || [];
                  if (!das.length) return '';
                  var nombres = [];
                  // Shopify marca con $0 las líneas que solo "califican" para el
                  // regalo (Compra X y obtén Y); ese nombre no aporta nada al cliente.
                  das.forEach(function (d) { if (!d.amount) return; var t = d.discount_application && d.discount_application.title; if (t && nombres.indexOf(t) < 0) nombres.push(t); });
                  return nombres.length ? '<span style="display:block;font-size:10.5px;color:' + VERDE_OK + ';margin-top:2px">' + esc(nombres.join(' · ')) + '</span>' : '';
                })() +
              '</div></div>';
          }).join('') : '<div class="empty">Tu carrito está vacío.</div>';
          // Descuentos a nivel PEDIDO (BLUE10% / MIPRIMERACOMPRA como "importe de
          // descuento en pedido"): Shopify no los reparte en final_line_price, así
          // que sin esta fila las líneas sumarían más que el total.
          // El monto se toma de los totales del carrito (items_subtotal_price −
          // total_price), no del objeto de la aplicación: ese objeto cambia de
          // forma según la versión de la API y llegó a pintar "−$NaN".
          var cartDesc = c.cart_level_discount_applications || [];
          var descPedido = (c.items_subtotal_price || 0) - (c.total_price || 0);
          if (c.items.length && descPedido > 0) {
            var nombresPed = [];
            cartDesc.forEach(function (d) {
              var a = d && d.discount_application ? d.discount_application : d;
              var t = a && (a.title || a.code);
              if (t && nombresPed.indexOf(t) < 0) nombresPed.push(t);
            });
            b.innerHTML += '<div class="ci ci-desc"><div class="t" style="color:' + VERDE_OK + '">' + esc(nombresPed.join(' · ') || 'Descuento') +
              '</div><div class="p" style="color:' + VERDE_OK + '">−' + dinero(descPedido) + '</div></div>';
          }
        }
        var t = $('#bl-dtot'); if (t) t.textContent = dinero(c.total_price);
        var m = $('#bl-dmsi');
        if (m) m.textContent = mensajeCarrito(c.total_price);
        // Si el total cambió y estamos en una ficha, la barra de envío se actualiza.
        if (c.total_price !== totalCarritoCent) {
          totalCarritoCent = c.total_price || 0;
          if (VAR && VAR.length) { try { pintarVariante(); } catch (e) {} }
        }
        try { gestionarRegalos(c); } catch (e) { if (window.console) console.warn('regalos:', e.message); }
        return c;
      })
      .catch(function () {});
  }

  function agregar(id, qty) {
    return fetch(BL.routes.cart_add + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'No se pudo agregar'); });
      return r.json();
    }).then(function () { toast(BL.strings.agregado); return pintarCarrito(); });
  }

  /* Cambia la cantidad de una línea del cajón.
     delta = +1 / −1 suma o resta; delta = 0 QUITA la línea completa (antes no
     había forma de quitar 50 unidades sin pulsar "−" 50 veces).
     Lee la cantidad que ya está en pantalla (sin petición extra), pinta con
     el carrito que devuelve /cart/change.js, y si Shopify rechaza (p. ej.
     más unidades que el stock) lo dice en vez de tragárselo. */
  var cambiando = false;
  function cambiar(keys, delta) {
    if (cambiando) return;              // evita que dos clics rápidos se pisen
    var span = $('[data-cqn="' + keys + '"]');
    var actual = span ? parseInt(span.textContent, 10) || 0 : 0;
    var nueva = delta === 0 ? 0 : Math.max(0, actual + delta);
    // Si Shopify había partido la línea, toda la cantidad va a la primera
    // clave y las demás a 0: vuelve a ser una sola línea.
    var lista = String(keys).split(','), updates = {};
    lista.forEach(function (k, n) { updates[k] = n === 0 ? nueva : 0; });
    cambiando = true;
    fetch(BL.routes.cart + '/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'No se pudo actualizar'); });
      return r.json();
    }).then(function (c) { return pintarCarrito(c); })
      .catch(function (err) { toast(err.message); pintarCarrito(); })
      .then(function () { cambiando = false; });
  }

  /* ── Regalos por nivel (reemplaza a CornerCart) ─────────────────────────
     Shopify hace el "gratis": un descuento automático "Compra X y obtén Y"
     por nivel (monto mínimo → 1 unidad del regalo al 100%). El tema hace lo
     interactivo: barra de progreso en el cajón y agregar/quitar el regalo del
     nivel alcanzado. Regla: NO acumulativo — solo el regalo del nivel más alto.
     Red de seguridad: si Shopify no dejó el regalo en $0, el tema lo quita y
     no lo vuelve a intentar en la sesión. Nunca se le cobra un regalo. */
  var regalosOcupado = false;
  var regalosFallidos = {};   // vid → true cuando Shopify no lo puso gratis

  function regalosCfg() {
    if (!BL.regalos_activos || !BL.regalos || !BL.regalos.length) return [];
    return BL.regalos.filter(function (r) { return r && r.vid && r.monto > 0 && !regalosFallidos[r.vid]; })
      .sort(function (a, b) { return a.monto - b.monto; });
  }
  /* Es regalo SOLO la línea marcada como regalo: _regalo (la agrega el tema)
     o _corner_promo_code (carritos viejos de CornerCart). NO se usa el precio
     $0 para decidir: Shopify aplica el "Compra X y obtén Y" del Termo a
     cualquier Termo del carrito, y una compra normal quedaba en $0 y el tema
     la borraba. */
  function esRegalo(item) {
    var p = item.properties || {};
    return !!(p._regalo || p._corner_promo_code);
  }
  // Base del nivel: suma de las líneas que NO son regalo, en lista o en pagado.
  function baseRegalos(c) {
    var lista = (BL.regalos_base || 'lista') === 'lista';
    return c.items.reduce(function (acc, i) {
      if (esRegalo(i)) return acc;
      return acc + (lista ? i.original_line_price : i.final_line_price);
    }, 0);
  }

  function pintarRegalos(c, cfg, base, meta) {
    var box = $('#bl-regalos'); if (!box) return;
    if (!cfg.length) { box.hidden = true; return; }
    var tope = cfg[cfg.length - 1].monto * 100;
    var pct = Math.max(0, Math.min(100, Math.round(base / tope * 100)));
    var sig = cfg.filter(function (r) { return base < r.monto * 100; })[0];
    var msg;
    if (meta && !sig) {
      msg = '<b>' + esc(meta.titulo) + '</b> va de regalo en tu pedido. Es el nivel máximo.';
    } else if (meta) {
      msg = '<b>' + esc(meta.titulo) + '</b> va de regalo. Agrega <b>' + dinero(sig.monto * 100 - base) + '</b> más y súbelo a <b>' + esc(sig.titulo) + '</b>.';
    } else {
      msg = 'Te faltan <b>' + dinero(sig.monto * 100 - base) + '</b> para tu regalo: <b>' + esc(sig.titulo) + '</b>.';
    }
    var hitos = cfg.map(function (r) {
      var x = Math.min(100, Math.round(r.monto * 100 / tope * 100));
      var on = base >= r.monto * 100;
      return '<div class="rg-hito' + (on ? ' on' : '') + '" style="left:' + x + '%">' +
        (r.img ? '<img src="' + r.img + '" alt="" width="28" height="28" loading="lazy">' : '<span class="rg-dot"></span>') +
        '<span class="rg-m">' + dinero(r.monto * 100) + '</span></div>';
    }).join('');
    box.innerHTML =
      '<div class="rg-t">' + esc(BL.regalos_titulo || '3 niveles. 3 regalos.') + '</div>' +
      '<div class="rg-msg">' + msg + '</div>' +
      '<div class="rg-track"><div class="rg-fill" style="width:' + pct + '%"></div>' + hitos + '</div>';
    box.hidden = false;
  }

  function gestionarRegalos(c) {
    var cfg = regalosCfg();
    var box = $('#bl-regalos');
    if (!cfg.length) { if (box) box.hidden = true; return; }
    if (regalosOcupado) return;

    var base = baseRegalos(c);
    var meta = null;
    cfg.forEach(function (r) { if (base >= r.monto * 100 && r.ok !== false) meta = r; });

    pintarRegalos(c, cfg, base, meta);

    // ¿Qué regalos hay hoy en el carrito y cuáles sobran?
    var enCarrito = c.items.filter(esRegalo);
    var acciones = [];
    enCarrito.forEach(function (i) {
      var esMeta = meta && i.variant_id === meta.vid;
      if (!esMeta) acciones.push({ id: i.key, quantity: 0 });                 // regalo de otro nivel o ya sin nivel
      else if (i.quantity !== 1) acciones.push({ id: i.key, quantity: 1 });   // solo 1 va gratis
      else if (i.final_line_price > 0) {                                      // Shopify NO lo puso gratis
        regalosFallidos[i.variant_id] = true;
        acciones.push({ id: i.key, quantity: 0 });
        if (window.console) console.warn('[BL] Regalo no quedó en $0; se retira. Revisar el descuento "Compra X y obtén Y" del nivel', meta.nivel);
      }
    });
    var faltaMeta = meta && !enCarrito.some(function (i) { return i.variant_id === meta.vid; });

    if (!acciones.length && !faltaMeta) return;   // estado correcto, nada que hacer
    regalosOcupado = true;

    /* Quitar/ajustar va por /cart/update.js (claves de línea). Agregar el
       regalo va por /cart/add.js con la propiedad oculta _regalo: update.js
       no puede poner propiedades y sin ella el regalo no se distingue de una
       compra normal del mismo producto. */
    var updates = {};
    acciones.forEach(function (a) { updates[a.id] = a.quantity; });
    if (box) box.classList.add('rg-cargando');
    var cab = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

    (acciones.length
      ? fetch(BL.routes.cart + '/update.js', { method: 'POST', headers: cab, body: JSON.stringify({ updates: updates }) })
          .then(function (r) { if (!r.ok) throw new Error('update'); return r.json(); })
      : Promise.resolve(null))
      .then(function (c2) {
        if (!faltaMeta) return c2;
        return fetch(BL.routes.cart_add + '.js', { method: 'POST', headers: cab,
          body: JSON.stringify({ items: [{ id: meta.vid, quantity: 1, properties: { _regalo: '1' } }] }) })
          .then(function (r) {
            if (!r.ok) { regalosFallidos[meta.vid] = true; throw new Error('add'); }
            return fetch(BL.routes.cart + '.js', { headers: { 'Accept': 'application/json' } });
          })
          .then(function (r) { return r.json(); });
      })
      .then(function (c) { regalosOcupado = false; if (box) box.classList.remove('rg-cargando'); return pintarCarrito(c); })
      .catch(function () { regalosOcupado = false; if (box) box.classList.remove('rg-cargando'); pintarCarrito(); });
  }

  /* ── ficha de producto: variantes de dos ejes ── */
  var VAR = null, sel = [], qty = 1;
  /* Total actual del carrito (centavos). La barra de envío gratis de la ficha
     lo suma a lo que el cliente está viendo: antes ignoraba el carrito y con
     $600 ya adentro decía "Añade $299 más" para un producto de $200 (M4). */
  var totalCarritoCent = 0;
  // Puente para que funciones fuera de initProducto (p. ej. el bundle) lean el campo de cantidad.
  var leerQtyGlobal = function () {};

  /* Precio efectivo de Google Automated Discounts (centavos), si aplica.
     Antes, el script de Google en theme.liquid pintaba el precio grande
     directo en el DOM, pero MSI/envío gratis/barra flotante seguían
     usando v.px (el precio real) — el cliente veía dos precios distintos
     en la misma pantalla. Ahora ese script solo AVISA el precio aquí, y
     pintarVariante() es el único lugar que decide qué mostrar en todos
     lados, con el mismo número. */
  var precioGoogle = null;
  var varGoogleId = null;

  function initProducto() {
    var el = document.getElementById('bl-variantes');
    if (!el) return;
    try { VAR = JSON.parse(el.textContent); } catch (e) { return; }
    // Si la URL trae ?variant=, esa manda. Google Shopping y los anuncios mandan ese
    // parametro y antes se ignoraba: el cliente aterrizaba viendo otra variante y otro precio.
    var pedida = null;
    try {
      var qv = new URL(window.location.href).searchParams.get('variant');
      if (qv) { qv = parseInt(qv, 10); pedida = VAR.filter(function (v) { return v.id === qv; })[0] || null; }
    } catch (e) { pedida = null; }
    var actual = pedida || VAR.filter(function (v) { return v.ok; })[0] || VAR[0];
    sel = actual.op.slice();

    // El precio de Google Automated Discounts es válido solo para la variante
    // que se muestra al cargar la página, así que se ancla a ese id.
    varGoogleId = actual.id;

    // Le damos a theme.liquid una forma de avisar el precio, llegue cuando llegue
    // (puede ser antes de que este script corra, o varios segundos después).
    BL.setPrecioGoogle = function (cent) {
      if (typeof cent !== 'number' || !(cent > 0) || cent === precioGoogle) return;
      precioGoogle = cent; pxEf._avisado = false; pintarVariante();
    };
    // Por si el aviso llegó antes de que existiera BL.setPrecioGoogle.
    if (typeof BL.precioGoogleCent === 'number') { precioGoogle = BL.precioGoogleCent; }

    pintarVariante();

    $$('#bl-opciones [data-op]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = parseInt(b.getAttribute('data-op'), 10) - 1;
        sel[i] = b.getAttribute('data-val');
        // Si la combinación no existe O existe pero sin stock, se ajustan los otros ejes
        // para caer en algo comprable. Antes solo se revisaba que existiera, y una
        // combinación agotada dejaba el selector en un callejón sin salida.
        var enc = buscar(sel);
        if (!enc || !enc.ok) {
          var alt = VAR.filter(function (v) { return v.ok && v.op[i] === sel[i]; })[0];
          if (alt) sel = alt.op.slice();
        }
        qty = 1;
        // El precio de Google era para OTRA variante — ya no aplica si el
        // cliente cambió de color/talla, para no seguir mostrando un
        // precio que no le corresponde a lo que tiene seleccionado ahora.
        // (El precio de Google ya no se borra aquí: pxEf() lo aplica solo si
        // la variante seleccionada es varGoogleId, así se restaura al volver.)
        pintarVariante();
      });
    });

    /* Cantidad. Tope: el stock de la variante (o 99 si no se conoce). */
    function topeQty() {
      var v = buscar(sel);
      return (v && v.q > 0) ? v.q : 99;
    }
    /* Lee lo que el cliente ESCRIBIÓ en el campo y lo vuelve la cantidad
       oficial. Antes qty solo cambiaba con los botones ±: el cliente
       tecleaba 3, pulsaba "Agregar" y se agregaba 1. */
    function leerQty() {
      var inp = $('[data-pq-input]'); if (!inp) return;
      var n = parseInt(inp.value, 10);
      if (isNaN(n)) n = 1;
      qty = Math.max(1, Math.min(n, topeQty()));
      inp.value = qty;
    }
    leerQtyGlobal = leerQty;

    $$('[data-pq]').forEach(function (b) {
      b.addEventListener('click', function () {
        qty = Math.max(1, Math.min(qty + parseInt(b.getAttribute('data-pq'), 10), topeQty()));
        var inp = $('[data-pq-input]'); if (inp) inp.value = qty;
        pintarVariante();
      });
    });

    var inpQty = $('[data-pq-input]');
    if (inpQty) {
      // change = al salir del campo o dar Enter. Aquí se valida, se ajusta al
      // tope y se repinta precio total / barra de envío con la cantidad real.
      inpQty.addEventListener('change', function () { leerQty(); pintarVariante(); });
      // Enter dentro del campo: que agregue, no que recargue la página.
      inpQty.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); leerQty(); pintarVariante(); var f = $('#bl-form'); if (f) f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event('submit', { cancelable: true })); }
      });
    }

    $$('#pthumbs [data-th]').forEach(function (b) {
      b.addEventListener('click', function () {
        var vid = b.getAttribute('data-video');
        if (!(vid && mostrarVideo(vid))) cambiarFoto(b.getAttribute('data-th'), b.getAttribute('data-th-id'));
        $$('#pthumbs button').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
      });
    });

    /* Los tres botones de compra leen el campo de cantidad justo antes de
       agregar (por si el cliente escribió y pulsó sin salir del campo) y
       TODOS avisan si Shopify rechaza (stock agotado en otra pestaña, etc.).
       Antes "Comprar ahora" y la barra flotante fallaban en silencio. */
    var form = $('#bl-form');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      leerQty();
      var v = buscar(sel); if (!v || !v.ok) return;
      agregar(v.id, qty).then(abrirCarrito).catch(function (err) { toast(err.message); });
    });
    var buy = $('#bl-buy');
    if (buy) buy.addEventListener('click', function () {
      leerQty();
      var v = buscar(sel); if (!v || !v.ok) return;
      agregar(v.id, qty).then(function () {
        /* Directo al pago. Si el tema está agregando el regalo del nivel, espera
           a que termine (máx. 4 s) para que el regalo llegue al checkout. */
        var t0 = Date.now();
        (function ir() {
          if (regalosOcupado && Date.now() - t0 < 4000) return setTimeout(ir, 150);
          window.location.href = '/checkout';
        })();
      }).catch(function (err) { toast(err.message); });
    });
    var mba = $('#mb-add');
    if (mba) mba.addEventListener('click', function () {
      leerQty();
      var v = buscar(sel); if (!v || !v.ok) return;
      agregar(v.id, qty).then(abrirCarrito).catch(function (err) { toast(err.message); });
    });
    cargarBundle();
  }

  /* Mantiene el JSON-LD (datos estructurados para Google) alineado con lo
     que el cliente ve: precio efectivo (variante elegida + Google Automated
     Discounts), disponibilidad y SKU. Google compara Merchant Center, el
     JSON-LD y el precio visible; si no coinciden, desaprueba la oferta. */
  function sincronizarLdJson(v, pxEfectivo) {
    var el = document.getElementById('bl-ldjson'); if (!el) return;
    try {
      var d = JSON.parse(el.textContent);
      if (!d || !d.offers) return;
      d.offers.price = Math.round(pxEfectivo) / 100;
      d.offers.availability = 'https://schema.org/' + (v.ok ? 'InStock' : 'OutOfStock');
      if (v.sku) d.sku = v.sku; else delete d.sku;
      if (VAR.length > 1 && d.offers.url) {
        d.offers.url = d.offers.url.split('?')[0] + '?variant=' + v.id;
      }
      el.textContent = JSON.stringify(d);
    } catch (e) {}
  }

  /* Precio efectivo de una variante: el de Google Automated Discounts si
     aplica (y es más bajo que el real), si no, el precio real. Un solo
     lugar que decide esto, para que precio grande, MSI, envío gratis,
     barra flotante y "cómpralo junto" nunca se contradigan entre sí.

     TOPE DE SEGURIDAD (14 sep 2026): se detectó en producción que el dato
     de Google llegaba con un número basura ($2,519 sobre un producto de
     $9,599, −74%) mientras el carrito cobraba $8,639 (el 10% real). La
     ficha prometía un precio que el checkout no cumplía — riesgo PROFECO.
     Por eso: si el "descuento" de Google supera BL.google_max_off (el
     máximo que Shopify tiene configurado para descuentos automáticos),
     el dato se descarta y se muestra el precio real. Descartar es más
     seguro que recortar: mostrar de más nunca es ilegal, mostrar de
     menos sí. */
  function pxEf(v) {
    // El precio de Google es válido SOLO para la variante con la que cargó la
    // página (varGoogleId). Si el cliente cambia de variante no se aplica; si
    // regresa a la original, se vuelve a aplicar. Antes se borraba al cambiar
    // y nunca se restauraba; y si Google avisaba tarde, se aplicaba a la
    // variante que estuviera seleccionada en ese momento, fuera cual fuera.
    if (precioGoogle == null || precioGoogle <= 0 || v.id !== varGoogleId || precioGoogle >= v.px) return v.px;
    var maxOff = (typeof BL.google_max_off === 'number') ? BL.google_max_off : 10;
    var minimoPermitido = v.px * (1 - maxOff / 100);
    if (precioGoogle < minimoPermitido) {
      if (!pxEf._avisado) {
        pxEf._avisado = true;
        console.warn('[BL] Precio de Google descartado por inverosímil.',
          { precioGoogle: precioGoogle / 100, precioReal: v.px / 100,
            descuento: Math.round((1 - precioGoogle / v.px) * 100) + '%',
            topePermitido: maxOff + '%' });
      }
      return v.px;
    }
    return precioGoogle;
  }

  function buscar(op) {
    for (var i = 0; i < VAR.length; i++) {
      var v = VAR[i], igual = true;
      for (var k = 0; k < op.length; k++) if (v.op[k] !== op[k]) { igual = false; break; }
      if (igual) return v;
    }
    return null;
  }

  function pintarVariante() {
    var v = buscar(sel) || VAR[0];
    var idIn = $('[data-variant-id]'); if (idIn) idIn.value = v.id;

    // la URL refleja la variante, para que se pueda compartir
    if (window.history && window.history.replaceState) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u.toString());
    }

    if (v.img) cambiarFoto(v.img, v.imgid);

    var pxEfectivo = pxEf(v);
    sincronizarLdJson(v, pxEfectivo);

    /* Misma regla que snippets/precio.liquid (lo que pinta el servidor al
       cargar), para que el precio no "salte" cuando el JS repinta:
       - tachado siempre que haya precio de referencia mayor;
       - badge "−X%" solo si el ajuste mostrar_descuento está activo y el
         descuento es ≥ 5%;
       - el % se TRUNCA (9.6% → 9), igual que Liquid: nunca anunciar más
         descuento del real (PROFECO). */
    var px = $('#bl-precio');
    if (px) {
      var ahora = pxEfectivo, ref = (pxEfectivo !== v.px) ? v.px : v.cmp;
      var off = (ref > ahora) ? Math.floor((ref - ahora) * 100 / ref) : 0;
      var badge = (BL.mostrar_descuento !== false && off >= 5) ? '<span class="off">−' + off + '%</span>' : '';
      px.innerHTML = '<div class="pxbig"><span class="now">' + dinero(ahora) + '</span>' +
        (ref > ahora ? '<span class="was">' + dinero(ref) + '</span>' + badge : '') + '</div>';
    }

    $$('#bl-opciones [data-op]').forEach(function (b) {
      var i = parseInt(b.getAttribute('data-op'), 10) - 1;
      var val = b.getAttribute('data-val');
      b.setAttribute('aria-pressed', sel[i] === val ? 'true' : 'false');
      var posible = VAR.some(function (x) {
        if (x.op[i] !== val || !x.ok) return false;
        for (var k = 0; k < sel.length; k++) if (k !== i && x.op[k] !== sel[k]) return false;
        return true;
      });
      // Se marca como no disponible pero SIGUE siendo clickeable. Con el atributo
      // disabled nativo el navegador no dispara click, y entonces el rescate de
      // initProducto() nunca corria: se podian apagar todas las opciones a la vez
      // y el selector se quedaba trabado sin salida.
      b.disabled = false;
      b.setAttribute('aria-disabled', posible ? 'false' : 'true');
      b.classList.toggle('no-hay', !posible);
    });
    $$('[data-op-sel]').forEach(function (s) {
      var i = parseInt(s.getAttribute('data-op-sel'), 10) - 1;
      s.textContent = sel[i] || '';
    });

    var msi = $('#bl-msi');
    if (msi) msi.innerHTML = (pxEfectivo >= centMsi()
      ? '<div class="r"><span>' + BL.msi + ' meses sin intereses</span><span>' + dinero(pxEfectivo / BL.msi) + ' / mes</span></div>' : '') +
      '<div class="r"' + (pxEfectivo >= centMsi() ? ' style="border-top:1px solid var(--line)"' : '') + '><span>Pago de una vez</span><span>' + dinero(pxEfectivo) + '</span></div>';

    var add = $('#bl-add');
    if (add) { add.disabled = !v.ok; add.textContent = v.ok ? 'Agregar al carrito' : 'Sin stock por ahora'; }
    var buy = $('#bl-buy'); if (buy) buy.disabled = !v.ok;

    /* Promesas al cliente: salen de los ajustes del Personalizador (vía
       window.BL en theme.liquid), no de números quemados. Antes decía
       "Llega el sábado 19" = hoy + 5 días naturales, contando domingos y
       festivos, y los ajustes dias_entrega / dias_devolucion /
       meses_garantia / mostrar_stock no los leía nadie. Ahora la ficha
       dice lo mismo que el checkout ("1 a N días hábiles"). */
    var dEnt = parseInt(BL.dias_entrega, 10) || 4;
    var dDev = parseInt(BL.dias_devolucion, 10) || 30;
    var mGar = parseInt(BL.meses_garantia, 10) || 12;
    var diasTxt = dEnt <= 1 ? '1 día hábil' : '1 a ' + dEnt + ' días hábiles';
    /* Sello "Envío rápido": destaca la promesa de entrega sin romper la
       estética. Pill en azul de marca + ícono SVG (los emojis cambian según
       el teléfono). El número de días sale del mismo ajuste dias_entrega. */
    var sello = '<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin:0 0 4px">' +
      '<span style="display:inline-flex;align-items:center;gap:6px;font-size:11.5px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:' + AZUL_MARCA + ';background:rgba(29,78,216,.08);border-radius:999px;padding:5px 11px 5px 9px;white-space:nowrap">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>' +
        'Envío rápido</span>' +
      '<span><b>Llega en ' + diasTxt + '</b> si compras hoy.</span></div>';
    var sh = $('#bl-ship');
    if (sh) sh.innerHTML = !v.ok
      ? '<div><b>Sin stock en esta combinación.</b> Prueba otro color o talla.</div>'
      : barraEnvio(tras_descuento(pxEfectivo * qty) + totalCarritoCent, totalCarritoCent > 0) +
        sello +
        (BL.mostrar_stock !== false && v.q > 0 ? '<div>Sale de nuestro almacén — <b>' + v.q + ' disponibles</b>.</div>' : '') +
        '<div>' + dDev + ' días para devolverlo. <b>Garantía ' + mGar + ' meses</b> con la marca.</div>';

    var sk = $('[data-sku]'); if (sk && v.sku) sk.textContent = v.sku;
    var mp = $('#mb-px'); if (mp) mp.textContent = dinero(pxEfectivo);
    var mm = $('#mb-msi');
    if (mm) mm.textContent = !v.ok ? 'Sin stock' : ((pxEfectivo >= centMsi() ? BL.msi + ' × ' + dinero(pxEfectivo / BL.msi) + ' sin intereses' : '') + (v.q > 0 ? ' · ' + v.q + ' disponibles' : ''));
    var mba = $('#mb-add'); if (mba) mba.disabled = !v.ok;
    // No pisar el campo mientras el cliente está escribiendo en él (el
    // repintado puede llegar en cualquier momento, p. ej. cuando Google avisa
    // su precio); el valor se recoge en change/Enter/al agregar.
    var inp = $('[data-pq-input]'); if (inp && document.activeElement !== inp) inp.value = qty;

    // "Cómpralo junto" sigue al precio/variante actual (antes se quedaba con la inicial).
    recalcBundle();
  }

  /* ── cómpralo junto ── */
  /* Normaliza un producto venga de donde venga. Las tres fuentes devuelven
     formas distintas: /recommendations/products.json trae price (centavos),
     featured_image (url) y available; /collections/x/products.json NO trae
     nada de eso a nivel producto (el precio va en variants[].price como
     texto "1234.00", las imágenes en images[].src). Antes se leía p.price
     directo y en el tercer caso salía "$NaN" e <img src="[object Object]">.
     Devuelve null si el producto no tiene ninguna variante disponible. */
  function normalizarProd(p) {
    if (!p || !p.variants || !p.variants.length) return null;
    var vd = null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available !== false) { vd = p.variants[i]; break; }
    }
    if (!vd) return null;
    var px = (typeof vd.price === 'string') ? Math.round(parseFloat(vd.price) * 100)
           : (typeof vd.price === 'number') ? vd.price
           : (typeof p.price === 'number') ? p.price : NaN;
    if (isNaN(px)) return null;
    var img = '';
    if (typeof p.featured_image === 'string') img = p.featured_image;
    else if (p.featured_image && p.featured_image.src) img = p.featured_image.src;
    else if (p.images && p.images[0]) img = (typeof p.images[0] === 'string') ? p.images[0] : (p.images[0].src || '');
    return { id: p.id, title: p.title || '', px: px, img: img, vid: vd.id };
  }

  function cargarBundle() {
    var box = $('[data-bundle]'); if (!box) return;
    var cuerpo = box.querySelector('[data-bundle-cuerpo]');
    var mio = String(box.getAttribute('data-pid') || '');
    var base = box.getAttribute('data-url') || '';

    function pedir(url) {
      return fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          return (d.products || []).map(normalizarProd).filter(function (p) { return p && String(p.id) !== mio; });
        })
        .catch(function () { return []; });
    }

    // Complementarios y relacionados se piden EN PARALELO (antes iban en
    // cascada: hasta 3 esperas seguidas antes de pintar nada).
    var uComp = base.replace('?', '.json?');
    var uRel  = uComp.replace('intent=complementary', 'intent=related');
    Promise.all([pedir(uComp), pedir(uRel)]).then(function (res) {
      var ps = res[0].length ? res[0] : res[1];
      if (ps.length) return pintar(ps.slice(0, 2));
      var h = box.getAttribute('data-col-handle');
      if (!h) { box.style.display = 'none'; return; }
      return pedir('/collections/' + h + '/products.json?limit=8').then(function (pc) {
        if (pc.length) pintar(pc.slice(0, 2)); else box.style.display = 'none';
      });
    });

    function pintar(prods) {
      var v = buscar(sel) || VAR[0];
      var pimg = $('#pimg');
      var fila = '<div class="bndrow"><div class="it"><img src="' + (pimg ? pimg.src : '') + '" alt="" width="64" height="64"><div class="p" data-bnd-mio>' + dinero(pxEf(v)) + '</div></div>';
      var chk = '<div class="bndchk"><label><input type="checkbox" checked disabled><span>' + esc(document.getElementById('pt').textContent) + '</span></label>';
      prods.forEach(function (p) {
        fila += '<div class="pl">+</div><div class="it"><img src="' + p.img + '" alt="" width="64" height="64" loading="lazy"><div class="p">' + dinero(p.px) + '</div></div>';
        chk += '<label><input type="checkbox" class="bchk" data-vid="' + p.vid + '" data-px="' + p.px + '" checked><span>' + esc(p.title) + ' — ' + dinero(p.px) + '</span></label>';
      });
      fila += '</div>'; chk += '</div>';
      cuerpo.innerHTML = fila + chk +
        '<div class="bndtot"><div><div class="t" id="btot"></div><div class="free" id="bfree"></div></div><button class="btn p" id="baddall">Agregar</button></div>';
      recalcBundle();
      $$('.bchk', box).forEach(function (c) { c.addEventListener('change', recalcBundle); });
      $('#baddall', box).addEventListener('click', function () {
        var btn = this;
        var vv = buscar(sel) || VAR[0];
        if (!vv.ok) { toast(BL.strings.sin_stock); return; }
        leerQtyGlobal();
        var items = [{ id: vv.id, quantity: qty }];
        $$('.bchk:checked', box).forEach(function (c) { items.push({ id: parseInt(c.getAttribute('data-vid'), 10), quantity: 1 }); });
        btn.setAttribute('aria-disabled', 'true');
        fetch(BL.routes.cart_add + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items })
        }).then(function (r) {
          // Antes no se revisaba la respuesta: con un complementario agotado
          // Shopify devolvía 422, no se agregaba nada, y el toast decía
          // "Agregado al carrito" abriendo un cajón vacío.
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'No se pudo agregar'); });
          return r.json();
        }).then(function () { toast(BL.strings.agregado); return pintarCarrito(); })
          .then(abrirCarrito)
          .catch(function (err) { toast(err.message); })
          .then(function () { btn.removeAttribute('aria-disabled'); });
      });
    }
  }

  /* Recalcula total y mensaje del bundle. También actualiza el precio del
     producto principal en la fila (antes se quedaba con el de la variante
     inicial al cambiar de color/talla). */
  function recalcBundle() {
    var box = $('[data-bundle]'); if (!box || !$('#btot')) return;
    var v = buscar(sel) || VAR[0];
    var mio = $('[data-bnd-mio]', box); if (mio) mio.textContent = dinero(pxEf(v));
    var tot = pxEf(v), n = 1;
    $$('.bchk:checked', box).forEach(function (c) { tot += parseInt(c.getAttribute('data-px'), 10); n++; });
    $('#btot').textContent = dinero(tot);
    $('#bfree').textContent = mensajeCarrito(tras_descuento(tot) + totalCarritoCent); // mismo criterio que la barra: descuento automático + lo que ya hay en el carrito
    $('#baddall').textContent = 'Agregar los ' + n;
  }

  /* ── portada rotativa ── */
  function initHero() {
    var slides = $$('[data-hs]'); if (slides.length < 2) return;
    var i = 0;
    function ir(k) {
      slides.forEach(function (s) { s.classList.toggle('on', parseInt(s.getAttribute('data-hs'), 10) === k); });
      $$('[data-hd]').forEach(function (b) { b.setAttribute('aria-pressed', parseInt(b.getAttribute('data-hd'), 10) === k ? 'true' : 'false'); });
    }
    var timer = setInterval(function () { i = (i + 1) % slides.length; ir(i); }, 6000);
    $$('[data-hd]').forEach(function (b) {
      b.addEventListener('click', function () { clearInterval(timer); ir(parseInt(b.getAttribute('data-hd'), 10)); });
    });
  }

  /* ── compra rápida en tarjetas ── */
  function initQuick() {
    document.addEventListener('click', function (e) {
      var ab = e.target.closest('[data-abrir-quick]');
      if (ab) {
        var panel = $('[data-quick="' + ab.getAttribute('data-abrir-quick') + '"]');
        if (panel) { panel.classList.remove('hidden'); ab.classList.add('hidden'); }
        return;
      }
      var dir = e.target.closest('[data-add-directo]');
      if (dir) { e.preventDefault(); agregar(parseInt(dir.getAttribute('data-add-directo'), 10), 1).then(abrirCarrito).catch(function (err) { toast(err.message); }); return; }

      // Círculo de color en la tarjeta: cambia la foto y deja lista esa variante.
      var sw = e.target.closest('[data-swcolor]');
      if (sw) {
        e.preventDefault();
        var card = sw.closest('.card');
        if (!card) return;
        $$('[data-swcolor]', card).forEach(function (x) { x.setAttribute('aria-pressed', x === sw ? 'true' : 'false'); });
        var nueva = sw.getAttribute('data-vimg');
        var img = $('.cimg img', card);
        if (nueva && img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = nueva; }
        // preselecciona la variante en el panel de compra rápida
        var vid = sw.getAttribute('data-vid');
        var panel = $('[data-quick="' + sw.getAttribute('data-swcolor') + '"]');
        if (panel && vid) {
          var encontrado = false;
          $$('[data-qv]', panel).forEach(function (b) {
            var esta = b.getAttribute('data-qv') === vid;
            b.setAttribute('aria-pressed', esta ? 'true' : 'false');
            if (esta) encontrado = true;
          });
          if (encontrado) $('[data-q-val]', panel).textContent = '1';
        }
        return;
      }

      // elegir variante dentro de la tarjeta
      var vb = e.target.closest('.qp [data-qv]');
      if (vb) {
        var cont = vb.closest('.qp');
        $$('[data-qv]', cont).forEach(function (x) { x.setAttribute('aria-pressed', x === vb ? 'true' : 'false'); });
        $('[data-q-val]', cont).textContent = '1';
        return;
      }
      // cantidad
      var qb = e.target.closest('.qp [data-q]');
      if (qb) {
        var c2 = qb.closest('.qp');
        var sel2 = $('[data-qv][aria-pressed="true"]', c2) || $('[data-qv]:not([disabled])', c2);
        var max = sel2 ? Math.max(1, parseInt(sel2.getAttribute('data-max'), 10) || 99) : 99;
        var span = $('[data-q-val]', c2);
        var n = Math.max(1, Math.min(parseInt(span.textContent, 10) + parseInt(qb.getAttribute('data-q'), 10), max));
        span.textContent = n;
        return;
      }
      // agregar
      var go = e.target.closest('[data-quick-go]');
      if (go) {
        var c3 = go.closest('.qp');
        var sel3 = $('[data-qv][aria-pressed="true"]', c3) || $('[data-qv]:not([disabled])', c3);
        if (!sel3) { toast(BL.strings.sin_stock); return; }
        var n3 = parseInt($('[data-q-val]', c3).textContent, 10) || 1;
        agregar(parseInt(sel3.getAttribute('data-qv'), 10), n3)
          .then(abrirCarrito).catch(function (err) { toast(err.message); });
        return;
      }
    });
  }

  /* ── visor de imágenes del producto ── */
  function initVisor() {
    var visor = document.getElementById('visor');
    var abrir = document.getElementById('ampliar');
    if (!visor || !abrir) return;
    // Solo fotos: la portada de un video no se amplía.
    var fotos = $$('#pthumbs [data-th]:not([data-video])').map(function (b) { return b.getAttribute('data-th'); });
    if (!fotos.length) { var p = $('#pimg'); if (p) fotos = [p.src]; }

    function pintar(src) {
      $('#visor-img').src = src;
      $$('#visor-thumbs button').forEach(function (b) {
        b.setAttribute('aria-current', b.getAttribute('data-vt') === src ? 'true' : 'false');
      });
    }
    $('#visor-thumbs').innerHTML = fotos.map(function (f) {
      return '<button data-vt="' + f + '"><img src="' + f + '" alt=""></button>';
    }).join('');
    abrir.addEventListener('click', function () {
      visor.classList.add('on');
      document.body.style.overflow = 'hidden';
      pintar($('#pimg').src);
    });
    visor.addEventListener('click', function (e) {
      if (e.target.closest('[data-visor-cerrar]')) {
        visor.classList.remove('on'); document.body.style.overflow = '';
        return;
      }
      var t = e.target.closest('[data-vt]');
      if (t) pintar(t.getAttribute('data-vt'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && visor.classList.contains('on')) {
        visor.classList.remove('on'); document.body.style.overflow = '';
      }
    });
  }

  /* ── mostrar agotados a petición ── */
  function initAgotados() {
    var b = document.getElementById('ver-agotados');
    if (!b) return;
    var ocultos = $$('.agotado-oculto');
    if (!ocultos.length) { b.parentNode.style.display = 'none'; return; }
    b.textContent = 'Ver también los ' + ocultos.length + ' agotados';
    b.addEventListener('click', function () {
      var abierto = ocultos[0].classList.contains('hidden');
      ocultos.forEach(function (o) { o.classList.toggle('hidden', !abierto); });
      b.textContent = abierto ? 'Ocultar los agotados' : ('Ver también los ' + ocultos.length + ' agotados');
    });
  }

  /* ── arranque ── */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-abrir-carrito]')) { e.preventDefault(); abrirCarrito(); return; }
    if (e.target.closest('[data-cerrar-carrito]')) { cerrarCarrito(); return; }
    var cq = e.target.closest('[data-cq]');
    if (cq) { cambiar(cq.getAttribute('data-cq'), parseInt(cq.getAttribute('data-d'), 10)); return; }
  });

  function arranca(nombre, fn) {
    try { fn(); } catch (err) { if (window.console) console.warn('bloque ' + nombre + ':', err.message); }
  }
  document.addEventListener('DOMContentLoaded', function () {
    arranca('hero', initHero);
    arranca('producto', initProducto);
    arranca('quick', initQuick);
    arranca('carrito', pintarCarrito);
    arranca('agotados', initAgotados);
    arranca('visor', initVisor);
  });
})();